import React from 'react';

const SecResearchFocus = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>연구개발 방향</h2>
      <div className={styles.divider} />

      <div className={styles.researchFocusBox}>
        <p className={styles.researchFocusText}>
          주식회사 메타에이아이는 <b>AI 시대에 요구되는 보안관리 체계</b>를 기반으로, 
          <b> 리눅스 서버 보안의 실질적 위협 요소</b>와 <b>방어 전략</b>을 분석하고, 
          <b> AI 기반 보안 자동화 기술</b>을 적용한 <b>지능형 보안관리 시스템</b>을 연구 · 개발하고 있습니다.
        </p>
      </div>
    </section>
  )
}

export default SecResearchFocus